import { useState } from 'react';
import { Section } from '../../types';
import { db } from '../../db';

interface SyncQueueItem {
  type: string;
  action: string;
  data: unknown;
  status: string;
  timestamp: number;
}

export function useSections(addToSyncQueue: (item: SyncQueueItem) => Promise<unknown>) {
  const [sections, setSections] = useState<Section[]>([]);

  const addSection = async (item: Section) => {
    const newItem = { ...item, order: sections.length };
    await db.sections.add(newItem);
    await db.syncStack.add({ type: 'section' as any, action: 'create', data: newItem, status: 'pending', timestamp: Date.now() });
    setSections(prev => [...prev, newItem]);
  };

  const updateSection = async (item: Section) => {
    await db.sections.put(item);
    await addToSyncQueue({ type: 'section' as any, action: 'update', data: item, status: 'pending', timestamp: Date.now() });
    setSections(prev => prev.map(s => s.id === item.id ? item : s).sort((a, b) => (a.order || 0) - (b.order || 0)));
  };

  const deleteSection = async (id: number) => {
    await db.sections.delete(id);
    await db.syncStack.add({ type: 'section' as any, action: 'delete', data: { id }, status: 'pending', timestamp: Date.now() });
    setSections(prev => prev.filter(s => s.id !== id));
  };

  return {
    sections,
    setSections,
    addSection,
    updateSection,
    deleteSection,
  };
}
